module.exports = __webpack_public_path__ + "img/IMG_3119_L_BlackMatted.4faf5527.jpg";